<template>
  <div class="px-4">
    <div class="album-list-results-container">
      <div class="tab-contents-header-container">
        <div class="row">
          <div class="col-sm-6">
            <h2 v-if="title != 'Fave Albums'" class="tab-contents-title">
              {{ title ? title : "Album Results" }}&nbsp;
              <span
                class="badge badge-space-grey badge-pill badge-tab-contents"
                v-if="showCounter && collectionTotal !== null"
              >
                {{ collectionTotal }}
              </span>
              <a
                href="#"
                class="badge badge-space-grey badge-pill badge-tab-contents"
                v-if="resourceUrlIsLibrary"
                @click.prevent="onClickShareLibrary"
              >
                <span>share</span>
                <i class="material-icons">screen_share</i>
              </a>
            </h2>

            <h2 v-if="title == 'Fave Albums'" class="tab-contents-title">
              <span
                >My
                <i
                  class="material-icons"
                  style="
                    font-size: 40px;
                    vertical-align: text-top;
                    color: #f7be2f;
                  "
                  >star_rate</i
                >
                Albums&nbsp; </span
              >&nbsp;
              <span
                class="badge badge-space-grey badge-pill badge-tab-contents"
                v-if="showCounter && collectionTotal !== null"
              >
                {{ collectionTotal }}
              </span>
              <a
                href="#"
                class="badge badge-space-grey badge-pill badge-tab-contents"
                v-if="resourceUrlIsLibrary"
                @click.prevent="onClickShareLibrary"
              >
                <span>share</span>
                <i class="material-icons">screen_share</i>
              </a>
            </h2>
          </div>

          <div class="col-sm-6 text-sm-right desktop-filter" v-if="!isMobile">
            <div class="d-inline-block">
              <div class="form-group form-inline">
                <div class="pr-2">
                  <label for="album-tab-content-filter-by"> Filter by: </label>
                </div>

                <input
                  type="text"
                  class="form-control"
                  id="album-tab-content-filter-by"
                  placeholder="album name..."
                  v-model="filterByAlbumName"
                />

                <a
                  href="#"
                  class="clear-search"
                  v-on:click="clearSearch()"
                  v-if="filterByAlbumName"
                >
                  <i class="material-icons">close</i>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-8 text-sm-right filter-container">
          <div class="pr-2">
            <label for="album-tab-content-filter-by"> Filter: </label>
          </div>

          <input
            type="text"
            class="form-control"
            id="album-tab-content-filter-by-mobile"
            placeholder="album name..."
            v-model="filterByAlbumName"
          />

          <a
            href="#"
            class="clear-search-mobile"
            v-on:click="clearSearch()"
            v-if="filterByAlbumName"
          >
            <i class="material-icons">close</i>
          </a>
        </div>
      </div>
    </div>

    <div class="album-list-collection-results">
      <div class="alert alert-space-grey" v-if="showEmptyAlbumBanner">
        Album results empty.
      </div>

      <!--<div class="alert alert-secondary newsletter-signup-new-albums mb-4" v-if="title == 'New Albums' && isAuthenticated && !newsletter" role="alert">-->
      <!--Click <a href="#" class="alert-link" v-on:click="newsletterSignup()">here</a> to sign up for the newsletter and get updates on new albums-->
      <!--</div>-->

      <div class="row">
        <div
          class="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 col-album-card-variable"
          v-for="(album, index) in albums"
          v-if="album && album !== null"
          :index="index"
          :key="index"
        >
          <div
            class="album-card-container"
            :class="'album-card-container-' + album.id"
          >
            <div class="album-img-container">
              <a
                :href="`?view-album=${album.id}`"
                v-on:click.prevent="onAlbumClick(album)"
              >
                <img
                  v-bind:src="
                    album.image
                      ? asseturl + album.image.replace(/^\/?/, '/')
                      : asseturl + '/images/player-no-album-img.png'
                  "
                  class="img-fluid"
                />
              </a>

              <button
                class="favourite"
                :class="{ favourited: isFavourite(album.id) }"
                data-toggle="tooltip"
                data-placement="top"
                v-bind:title="
                  isFavourite(album.id) ? 'Unfavourite' : 'Favourite'
                "
                @click="
                  isFavourite(album.id)
                    ? unfavourite(album.id)
                    : favourite(album.id)
                "
              >
                <i class="material-icons">star_rate</i>
              </button>
            </div>

            <div class="album-info-container">
              <h4 class="album-title">
                <a href="#" v-on:click.prevent="onAlbumClick(album)">
                  {{ album.name }}
                </a>
              </h4>

              <!--<p class="album-count">
                                &lt;!&ndash;Albums: {{ album.albums_count }}&ndash;&gt;
                                </p>-->

              <a href="#" @click.prevent="shareAlbum(album)">
                <i class="material-icons">screen_share</i>
              </a>

              <a href="#" @click.prevent="downloadAlbum(album)">
                <i class="material-icons">get_app</i>
              </a>

              <span class="preview-album">
                <a
                  href="#"
                  class="preview-link float-right"
                  v-on:click="albumPreview(album.id)"
                >
                  <i class="material-icons"></i>
                  <span class="preview-text">Preview</span>
                </a>
                <br />
                <div class="preview-controls">
                  <a
                    href="#"
                    class="preview-control next-link float-right"
                    v-on:click="previewNextTrack(album.id)"
                  >
                    <i class="material-icons">skip_next</i>
                  </a>
                  <a
                    href="#"
                    class="preview-control pause-link float-right"
                    v-on:click="previewPauseTrack(album.id)"
                  >
                    <i class="material-icons"></i>
                  </a>
                  <a
                    href="#"
                    class="preview-control stop-link float-right"
                    v-on:click="previewStopTrack(album.id)"
                  >
                    <i class="material-icons">stop</i>
                  </a>
                  <a
                    href="#"
                    class="preview-control previous-link float-right"
                    v-on:click="previewPreviousTrack(album.id)"
                  >
                    <i class="material-icons">skip_previous</i>
                  </a>
                </div>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div
        class="mb-2 text-center"
        style="margin-top: 5vh"
        v-waypoint="{ active: true, callback: onWaypoint }"
      >
        <a
          href="#"
          v-show="showLoadMoreButton"
          class="btn btn-light btn-sm"
          @click.prevent="onLoadMoreClick"
        >
          Load more Albums
        </a>
      </div>
    </div>

    <loading v-if="showLoader" v-bind:label="'Loading - Album list updating'">
    </loading>
  </div>
</template>

<style>
.form-control:focus {
  box-shadow: none;
}

.filter-container {
  display: none;
}

.clear-search {
  color: white;
  margin: 0 3px 0 0;
  padding: 0.375rem 1.25rem;
  position: absolute;
  right: 0;
  z-index: 1;
}

.clear-search-mobile {
  color: white;
  margin: 0;
  padding: 0.375rem 1.25rem;
  position: absolute;
  right: 0;
  z-index: 1;
}

.album-list-collection-results {
  padding-bottom: 20px;
}
</style>

<script>
import Vue from "vue";
import { playerService } from "../player-service";
import { audioService } from "../audio-service";
import ToastrType from "../toastr-types.interface";
import searchResultStore from "../search-result-store";
import _ from "lodash";

export default Vue.component("album-list-results", {
  data: function () {
    return {
      albums: [],
      showLoader: false,
      pagination: null,
      collectionTotal: null,
      jqxhr: false,
      filterByAlbumName: null,
      searchQuery: null,
      oldAlbumResourceUrl: false,
      oldSearchFilters: false,
      showEmptyAlbumBanner: true,
      ascendingAlbumIdsTmp: [],
      currentlySelected: window.currentlySelectedAlbum,
      isAuthenticated: window.authenticatedUserEmail !== false,
      newsletter: window.authenticatedUserNewsletter,
      currentLoadPromise: null,
      requestId: 0,
    };
  },

  props: {
    title: {
      default: false,
      required: false,
    },
    asseturl: {
      required: true,
    },

    showCounter: {
      type: Boolean,
      default: true,
      required: false,
    },

    albumResourceUrl: {
      default: false,
      required: false,
    },

    albumListEventId: {
      required: false,
    },

    searchFilters: {
      required: false,
      default: false,
    },
  },

  computed: {
    isMobile: function () {
      return $("html").hasClass("is-mobile-os") || window.innerWidth < 768;
    },

    resourceUrlIsLibrary: function () {
      let splitResourceUrl = this.albumResourceUrl.split("/");

      if (
        typeof splitResourceUrl[2] != "undefined" &&
        splitResourceUrl[2] == "libraries"
      ) {
        return true;
      } else {
        return false;
      }
    },

    showLoadMoreButton() {
      return (
        this.collectionTotal > this.albums.length &&
        !this.showLoader &&
        this.pagination &&
        this.pagination.next_page_url
      );
    },
  },

  methods: {
    isUrl(string) {
      if (!string) return false;

      const hasProtocol = /^https?:\/\//i.test(string);
      const withProtocol = hasProtocol ? string : `https://${string}`;

      try {
        const url = new URL(withProtocol);
        return Boolean(url.hostname.includes("."));
      } catch (err) {
        return false;
      }
    },

    onClickShareLibrary: function () {
      let splitResourceUrl = this.albumResourceUrl.split("/");

      if (
        typeof splitResourceUrl[2] != "undefined" &&
        splitResourceUrl[2] == "libraries" &&
        typeof splitResourceUrl[3] != "undefined"
      ) {
        playerService.shareLibrary(splitResourceUrl[3]);
      }
    },

    isFavourite: function (albumId) {
      return window.favAlbums.indexOf(albumId) !== -1;
    },

    onWaypoint({ going, direction }) {
      if (
        going === this.$waypointMap.GOING_IN &&
        (direction === this.$waypointMap.DIRECTION_TOP ||
          direction === this.$waypointMap.DIRECTION_RIGHT)
      ) {
        // An empty grid shows the waypoint at once; don't start a second load while one is in flight.
        if (this.collectionTotal != null && !this.showLoader) {
          if (this.pagination == null) {
            this.loadCollection();
          } else {
            this.loadCollection("next");
          }
        }
      }
    },

    // On clicking the Load More button at the bottomm of the album results.
    onLoadMoreClick() {
      let waypointConfig = {
        going: this.$waypointMap.GOING_IN,
        direction: this.$waypointMap.DIRECTION_TOP,
      };

      this.onWaypoint(waypointConfig);
    },

    onAlbumClick: function (album) {
      window.cancelAlbumResultsAlterations = false;

      $(".currently-selected").removeClass("currently-selected");

      window.currentlySelectedAlbum = album.id;

      let clearFiltering = false;

      // Don't clear filters if were on a tracksearch.
      if (this.albumResourceUrl.indexOf("albumsearchfromtracks") !== -1) {
        clearFiltering = false;
      } else {
        playerService.$emit("clear-search-terms-silently");
      }

      // Grab the tracks now.
      playerService.trackResultsFromAlbum(album.id, true, clearFiltering);

      let albumData = {
        type: "Album",
        id: album.id,
        name: album.name,
      };

      // Add this to search history.
      let searchHistory = [];

      try {
        // Looop through our search history, if the current search value exists, move it to the top.
        if (playerService.getLs("search")) {
          searchHistory = JSON.parse(playerService.getLs("search"));

          for (let value in searchHistory) {
            if (
              JSON.stringify(searchHistory[value]) == JSON.stringify(albumData)
            ) {
              searchHistory.splice(value, 1);
            }
          }
        } else {
          searchHistory = [];
        }

        searchHistory.unshift(albumData);
      } catch (err) {}

      playerService.setLs(
        "search",
        JSON.stringify(searchHistory),
        60 * 60 * 24000,
      );
    },

    unfavourite: function (albumId) {
      playerService.removeFavouriteAlbum(albumId);
    },

    favourite: function (albumId) {
      playerService.addFavouriteAlbum(albumId);
    },

    albumPreview: function (albumId) {
      let ctx = this;

      $(".album-card-container").each(function () {
        if ($(this).hasClass("album-card-container-" + albumId)) {
        } else {
          $(this).find(".preview-album").removeClass("playing");
        }
      });

      $(".card-player-collection").each(function () {
        $(this).find(".preview-playlist").removeClass("playing");
      });

      if (
        $(".album-card-container-" + albumId + " .preview-album").hasClass(
          "playing",
        )
      ) {
        $(".album-card-container-" + albumId + " .preview-album").removeClass(
          "playing",
        );
        $(".preview-control.pause-link").addClass("paused");
        audioService.pause();
      } else {
        $(".album-card-container-" + albumId + " .preview-album").addClass(
          "playing",
        );
        $(".album-card-container-" + albumId + " .preview-album").addClass(
          "hide-prev",
        );
        $(".preview-control.pause-link").removeClass("paused");

        let ajaxConfig = {
          method: "GET",
          url: "/api/albums/getfirsttrack/" + albumId,
          cache: false,
        };

        ctx.jqxhr = $.ajax(ajaxConfig)
          .done(function (response) {
            if (typeof response !== "undefined") {
              let first_track = response;
              audioService.stream(first_track);
            } else {
              if (window.adminProjectShare == true) {
                playerService.toast(
                  `[PLYR_221315] Error: Album Resource response was obtained but invalidated data schema was provided.`,
                  ToastrType.Error,
                );
              }
            }
          })
          .fail(function (responseData) {
            playerService.toast(
              `[PLYR_41648] Error: Could not load Track.`,
              ToastrType.Error,
            );

            if (
              typeof responseData.status !== "undefined" &&
              responseData.status == 419
            ) {
              playerService.$emit("open-browser-idle-too-long-modal");
            }
          });
      }
    },

    previewNextTrack: function (albumId) {
      let ctx = this;

      if (
        $(".album-card-container-" + albumId + " .preview-album").hasClass(
          "hide-next",
        )
      ) {
        return;
      }

      let currentTrack = $(".now-playing-track").attr("data-track-id");

      let ajaxConfig = {
        method: "GET",
        url: "/api/albums/getnexttrack/" + albumId + "/" + currentTrack,
        cache: false,
      };

      ctx.jqxhr = $.ajax(ajaxConfig)
        .done(function (response) {
          if (typeof response !== "undefined") {
            audioService.stream(response.data[0]);

            if (response.data[0].track_number > 1) {
              $(
                ".album-card-container-" + albumId + " .preview-album",
              ).removeClass("hide-prev");
            }

            if (response.message == "end") {
              $(
                ".album-card-container-" + albumId + " .preview-album",
              ).addClass("hide-next");
            }
          } else {
            if (window.adminProjectShare == true) {
              playerService.toast(
                `Error: Could not load Next Track.`,
                ToastrType.Error,
              );
            }
          }
        })
        .fail(function (responseData) {
          playerService.toast(
            `[PLYR_41648] Error: Could not load Track.`,
            ToastrType.Error,
          );

          if (
            typeof responseData.status !== "undefined" &&
            responseData.status == 419
          ) {
            playerService.$emit("open-browser-idle-too-long-modal");
          }
        });
    },

    previewPreviousTrack: function (albumId) {
      let ctx = this;

      if (
        $(".album-card-container-" + albumId + " .preview-album").hasClass(
          "hide-prev",
        )
      ) {
        return;
      }

      let currentTrack = $(".now-playing-track").attr("data-track-id");

      let ajaxConfig = {
        method: "GET",
        url: "/api/albums/getprevioustrack/" + albumId + "/" + currentTrack,
        cache: false,
      };

      ctx.jqxhr = $.ajax(ajaxConfig)
        .done(function (response) {
          if (typeof response !== "undefined") {
            audioService.stream(response[0]);

            $(
              ".album-card-container-" + albumId + " .preview-album",
            ).removeClass("hide-next");

            if (response[0].track_number == 1) {
              $(
                ".album-card-container-" + albumId + " .preview-album",
              ).addClass("hide-prev");
            }
          } else {
            if (window.adminProjectShare == true) {
              playerService.toast(
                `Error: Could not load Previous Track.`,
                ToastrType.Error,
              );
            }
          }
        })
        .fail(function (responseData) {
          playerService.toast(
            `[PLYR_41648] Error: Could not load Track.`,
            ToastrType.Error,
          );

          if (
            typeof responseData.status !== "undefined" &&
            responseData.status == 419
          ) {
            playerService.$emit("open-browser-idle-too-long-modal");
          }
        });
    },

    previewPauseTrack: function (albumId) {
      if ($(".preview-control.pause-link").hasClass("paused")) {
        audioService.play();
        $(".preview-control.pause-link").removeClass("paused");
      } else {
        audioService.pause();
        $(".preview-control.pause-link").addClass("paused");
      }
    },

    previewStopTrack: function (albumId) {
      $(".album-card-container-" + albumId + " .preview-album").removeClass(
        "playing",
      );
      audioService.pause();
      $(".preview-control.pause-link").addClass("paused");
    },

    /**
     * Loads the album resource, expects a well formed laravel collection with pagination (even if only single page for uniformity).
     *
     * @param paginationDir
     * @returns {boolean}
     */
    loadCollection: function (paginationDir = false) {
      // Return a promise for the entire operation
      const requestId = ++this.requestId;
      return new Promise((resolve, reject) => {
        if (window.cancelAlbumResultsAlterations == true) {
          const isSearchList =
            this.albumListEventId ==
              window.searchTrackResultsAlbumListEventId &&
            this.albumResourceUrl.indexOf("albumsearch") != -1;
          if (!isSearchList) {
            window.cancelAlbumResultsAlterations = false;
          }
          return resolve(false);
        }

        if (
          typeof this.albumResourceUrl === "undefined" ||
          this.albumResourceUrl === false
        ) {
          if (window.adminProjectShare == true) {
            playerService.toast(
              "[PLYR_221313] Error: Could not load album resource into album list. Invalid album resource url given.",
              ToastrType.Error,
            );
          }

          this.reset();

          return resolve(false);
        }

        if (window.trackAndAlbumCancelledSteps !== false) {
          window.trackAndAlbumCancelledSteps.album = true;

          if (
            window.trackAndAlbumCancelledSteps.track === true &&
            window.trackAndAlbumCancelledSteps.album === true
          ) {
            window.trackAndAlbumCancelledSteps = false;
          }
        }

        // Lets assume we don't want an error but we don't want to load the album resource for this album list yet.
        if (this.albumResourceUrl === "") {
          this.reset();

          return resolve(false);
        }

        this.showEmptyAlbumBanner = false;

        //If guests request Fave Albums show them auth popup
        if (
          this.albumResourceUrl == "/api/favourite-albums/albums" &&
          window.authenticatedUserEmail == false
        ) {
          playerService.$emit("feature-requires-auth-modal");
          return resolve(false);
        }

        let ctx = this;
        let loadAlbumUrl = this.albumResourceUrl;

        if (paginationDir === "next") {
          if (
            this.pagination !== null &&
            this.pagination.next_page_url !== null
          ) {
            loadAlbumUrl = this.pagination.next_page_url;
          } else {
            ctx.showLoader = false;

            return resolve(false);
          }
        } else if (paginationDir === "prev") {
          if (
            this.pagination !== null &&
            this.pagination.prev_page_url !== null
          ) {
            loadAlbumUrl = this.pagination.prev_page_url;
          } else {
            ctx.showLoader = false;

            return resolve(false);
          }
        }

        ctx.showLoader = true;

        let ajaxConfigGetData = {};

        if (ctx.filterByAlbumName) {
          ajaxConfigGetData["filter-by-name"] = ctx.filterByAlbumName;
        }

        let ajaxConfig = {
          method: "GET",
          url: loadAlbumUrl.replace("http:", "https:"),
          cache: false,
          data: ajaxConfigGetData,
          headers: {
            "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
          },
        };

        if (
          this.albumListEventId == window.searchTrackResultsAlbumListEventId &&
          loadAlbumUrl.indexOf("albumsearch") != -1
        ) {
          // Our main search album listing searches slightly different.

          ajaxConfig = {
            method: "POST",
            url: loadAlbumUrl.replace("http:", "https:"),
            data: {
              query: ctx.searchQuery,
              filters: ctx.searchFilters,
              filterByAlbumName: ctx.filterByAlbumName,
            },
            cache: false,
            headers: {
              "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
          };

          const searchResults = searchResultStore.current();

          if (
            loadAlbumUrl.indexOf("albumsearchfromtracks") != -1 &&
            searchResults
          ) {
            // JSON: a form-encoded list over 1,000 ids breaks on max_input_vars.
            ajaxConfig.contentType = "application/json";
            ajaxConfig.data = JSON.stringify({
              album_ids: searchResults.results.album_ids,
              filterByAlbumName: ctx.filterByAlbumName,
            });
          }
        }

        ctx.jqxhr = $.ajax(ajaxConfig)
          .done(function (response) {
            // Ignore stale responses from before the last reset()
            if (ctx.requestId !== requestId) {
              return resolve(false);
            }
            // We expect the pagination and album data to be inside the 'data' object. Outside of it should be response and status information.
            if (
              typeof response.data !== "undefined" &&
              typeof response.data.data !== "undefined"
            ) {
              // ctx.albums = response.data.data;
              ctx.albums.push(...response.data.data);
              ctx.pagination = response.data;

              if (
                typeof ctx.pagination != "undefined" &&
                typeof ctx.pagination.total != "undefined"
              ) {
                ctx.collectionTotal = ctx.pagination.total;
              } else {
                // fallback to the collection total.
                ctx.collectionTotal = ctx.albums.length;
              }

              // If we have a album list event id set, let's emit some data to it incase. If one isn't set they don't want to listen to any events emitted from this.
              if (ctx.albumListEventId) {
                playerService.$emit(
                  "album-list-resource-updated-" + ctx.albumListEventId,
                  {
                    collectionTotal: ctx.collectionTotal,
                    albums: ctx.albums,
                  },
                );
              }

              if (response.data.data.length == 0) {
                this.showEmptyAlbumBanner = true;
              }

              // Resolve the promise with success data
              resolve({
                success: true,
                response,
                collectionTotal: ctx.collectionTotal,
              });
            } else {
              if (window.adminProjectShare == true) {
                playerService.toast(
                  `[PLYR_221315] Error: Album Resource response was obtained but invalidated data schema was provided.`,
                  ToastrType.Error,
                );
              }
            }
          })
          .fail(function (responseData) {
            // Aborted (status 0) — treat as cancelled, not an error
            if (responseData.status === 0) {
              return resolve(false);
            }

            if (
              typeof responseData.status !== "undefined" &&
              responseData.status == 419
            ) {
              // CSRF issue/Timed out/logged out, idled too long.
              playerService.$emit("open-browser-idle-too-long-modal");
            } else {
              // Show error for other failures
              playerService.toast(
                `[PLYR_41648] Error: Could not load Albums.`,
                ToastrType.Error,
              );
            }

            // Reject the promise with error data
            reject(responseData);
          })
          .always(function (responseData) {
            ctx.showLoader = false;
          });
      });
    },

    reset: function () {
      if (window.cancelAlbumResultsAlterations == true) {
        const isSearchList =
          this.albumListEventId == window.searchTrackResultsAlbumListEventId &&
          this.albumResourceUrl.indexOf("albumsearch") != -1;
        if (!isSearchList) {
          window.cancelAlbumResultsAlterations = false;
        }
        return;
      }

      this.oldAlbumResourceUrl = this.albumResourceUrl;
      this.oldSearchFilters = this.searchFilters;

      window.webpackDestroyBsTooltipWorkaround(
        $(this.$el).find('[data-toggle="tooltip"]'),
      );

      this.requestId++;
      this.albums = [];
      this.pagination = null;
      this.collectionTotal = 0;

      window.currentlySelectedAlbum = 0;

      // Kill any ongoing ajax requests.
      if (this.jqxhr != false) {
        this.jqxhr.abort();
      }
    },

    shareAlbum: function (album) {
      playerService.shareAlbum(album);
    },

    downloadAlbum: function (album) {
      // playerService.downloadAlbumTracks( album );
      playerService.openDownloadTrackCollection(
        album.name,
        album.id,
        "albums",
        false,
      );
    },

    onUpdateFavouriteAlbumsListing: function () {
      this.reset();

      this.loadCollection();
    },

    clearSearch: function () {
      this.filterByAlbumName = null;
    },

    newsletterSignup: function () {
      $.ajax({
        method: "GET",
        url: "/user/newslettersignup",
        cache: false,
      })
        .done(function (response) {
          if (response.data == 1) {
            playerService.toast(
              `Signed up to newsletter successfully`,
              ToastrType.Success,
            );
          }

          $(".newsletter-signup-new-albums").hide();
        })
        .fail(function (responseData) {
          if (window.adminProjectShare == true) {
            playerService.toast(
              `[PLYR_151229] Error: Could not sign up to newsletter.`,
              ToastrType.Error,
            );
          }
        });
    },

    sortAlbumResults: function (albumIds) {
      // As req. we dont want this on libraries. New albums, or All Albums.
      // Break up the URL so we can determine it's intentions.
      let splitResourceUrl = this.albumResourceUrl.split("/");

      let isAllAlbumsUrl =
        typeof splitResourceUrl[2] != "undefined" &&
        splitResourceUrl[2].indexOf("albums") != -1 &&
        !splitResourceUrl[3];
      let isNewAlbumsUrl = this.albumResourceUrl.indexOf("albums-new") != -1;

      if (!this.resourceUrlIsLibrary && !isAllAlbumsUrl && !isNewAlbumsUrl) {
        // this.albums = [];

        setTimeout(() => {
          // Remove dupe from the album ids.
          let sortedAlbumIds = _.uniq(albumIds);

          //don't change album results if only 1 (i.e when clicking an album)
          if (sortedAlbumIds.length < 2) {
            return false;
          }

          // Sort by ascending
          function sortNumber(a, b) {
            return a - b;
          }

          let ascSortedAlbumIds = sortedAlbumIds.slice();

          ascSortedAlbumIds.sort(sortNumber);

          // Check ascending albumIds is not the same as current ascending albumIds
          if (_.isEqual(this.ascendingAlbumIdsTmp, ascSortedAlbumIds)) {
            return false;
          }

          // Sort the albums using these de-duped array of album ids.
          let sortedAlbums = _.sortBy(this.albums, function (album) {
            // If not in the current collection add it towards the end.
            if (sortedAlbumIds.indexOf(album["id"]) == -1) {
              return sortedAlbumIds.length;
            } else {
              return sortedAlbumIds.indexOf(album["id"]);
            }
          });

          // Reset the collection to this one.
          this.albums = sortedAlbums;
          // Now update our ascendingAlbuMidsTmp
          this.ascendingAlbumIdsTmp = ascSortedAlbumIds;
        }, 350);
      }
    },

    filterAlbums: _.debounce(function () {
      // Clear our current tracks as we don't want to add any different albums on the end.
      this.reset();

      // Kickoff the loader to get the new albums.
      this.loadCollection();
    }, 500),
  },

  mounted: function () {
    let ctx = this;

    // Clear album results immediately when new search starts
    playerService.$on("clear-album-results", () => {
      this.reset();
    });

    if (this.albumResourceUrl != false) {
      this.loadCollection();
    }

    playerService.$on(
      "search-query-updated",
      (query, cancelCollectionReload = false) => {
        this.searchQuery = query;

        if (
          this.albumListEventId === window.searchTrackResultsAlbumListEventId
        ) {
          return;
        }

        if (cancelCollectionReload === false) {
          this.reset();

          // Kickoff the loader to get the new albums.
          this.loadCollection();
        }
      },
    );

    playerService.$on("reset-album-results", () => {
      this.albums = [];
    });

    playerService.$on("album-list-results-reset-filter-by", () => {
      this.clearSearch();
      this.reset();
      if (this.albumListEventId !== window.searchTrackResultsAlbumListEventId) {
        this.loadCollection();
      }
    });
    playerService.$on("fav-albums-count-updated", (count) => {
      if (ctx.title == "Fave Albums") {
        $("span.badge-tab-contents").text(count);
      }
    });

    // When the track results updates and we get a sort order for the albums. Reorder our albums accordingly.
    playerService.$on("sort-album-results", this.sortAlbumResults);

    playerService.$on("clear-album-filter", () => {
      this.clearSearch();
    });
  },

  updated: function () {
    window.webpackDestroyBsTooltipWorkaround(
      $(this.$el).find('[data-toggle="tooltip"]'),
    );

    // Initialise our tooltips manually.
    window.webpackReinitBsTooltipWorkaround(
      $(this.$el).find('[data-toggle="tooltip"]'),
    );
  },

  watch: {
    albumResourceUrl: function (value, oldValue) {
      /*console.groupCollapsed( '[album-list] Resource URL has changed: ' );
         console.log( value );
         console.groupEnd();*/

      this.reset();
      let ctx = this;

      if (value == "/api/favourite-albums/albums") {
        // Keep our projects for the component up to date.
        playerService.$on(
          "update-favourite-albums-listing",
          ctx.onUpdateFavouriteAlbumsListing,
        );

        // If this is favourite albums listing, then remove the album.

        playerService.$on("fav-album-unfavourited", (favAlbumId) => {
          window.webpackDestroyBsTooltipWorkaround(
            $(this.$el).find('[data-toggle="tooltip"]'),
          );

          // Remove from collection.
          for (let favAlbum in this.albums) {
            if (ctx.albums.hasOwnProperty(favAlbum)) {
              ctx.albums[favAlbum] = null;
            }
          }

          // Remove from view.
          $(this.$el)
            .find(".album-card-container-" + favAlbumId)
            .parent()
            .remove();
        });
      } else {
        playerService.$off("update-favourite-albums-listing");
        playerService.$off("fav-album-unfavourited");
      }

      // Kickoff the loader to get the new albums.
      this.currentLoadPromise = this.loadCollection();
    },

    searchFilters: function (value, oldValue) {
      /*console.groupCollapsed( '[album-list] Filtering has changed: ' );
         console.log( value );
         console.groupEnd();*/
      // Clear our current tracks as we don't want to add any different albums on the end.
      //this.reset();
      // Kickoff the loader to get the new albums.
      //this.loadCollection();
    },

    filterByAlbumName: function (value) {
      /*console.groupCollapsed( '[album-list] filterByAlbumName has changed: ' );
         console.log( value );
         console.groupEnd();*/

      this.filterAlbums();

      if (value == null) {
        playerService.$emit("albums-not-filtered");
      } else {
        playerService.$emit("albums-filtered");
      }
    },
  },
});
</script>
